import React from 'react';
import {DashboardSidebar} from '@PikaDoApp/pikado-web-dsm';
import {useNavigate} from 'react-router-dom';
import {
  DashboardHomeIcon,
  PhilosophyIcon,
  PrivacyPolicyIcon,
  TermsIcon,
} from './Icons';

interface ReportSidebarProps {
  isMobileOpen: boolean;
  onMobileClose: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

const getMenuSections = () => [
  {
    id: 'dashboards',
    title: 'DASHBOARDS',
    items: [
      {
        id: 'english-dashboard',
        label: 'English Dashboard',
        icon: <DashboardHomeIcon />,
        isActive: true,
      },
    ],
  },
  {
    id: 'academic-philosophy',
    title: 'ACADEMIC PHILOSOPHY',
    items: [
      {
        id: 'why-pikado',
        label: 'Why PikaDo English',
        icon: <PhilosophyIcon />,
      },
    ],
  },
  {
    id: 'legal',
    title: 'LEGAL',
    items: [
      {
        id: 'privacy-policy',
        label: 'Privacy Policy',
        icon: <PrivacyPolicyIcon />,
      },
      {
        id: 'terms-conditions',
        label: 'Terms & Conditions',
        icon: <TermsIcon />,
      },
    ],
  },
];

export const ReportSidebar: React.FC<ReportSidebarProps> = ({
  isMobileOpen,
  onMobileClose,
  isCollapsed,
  onToggleCollapse,
}) => {
  const navigate = useNavigate();

  const handleMenuItemClick = (sectionId: string, itemId: string) => {
    // English Dashboard - navigate to home
    if (itemId === 'english-dashboard') {
      navigate('/');
      return;
    }

    // Privacy Policy - open in new tab
    if (itemId === 'privacy-policy') {
      window.open('https://pikado.io/privacy', '_blank', 'noopener,noreferrer');
      return;
    }

    // All other items: no action (shield-dashboard, why-pikado, terms-conditions)
    // Just return without doing anything
  };

  return (
    <DashboardSidebar
      menuSections={getMenuSections()}
      onMenuItemClick={handleMenuItemClick}
      isMobileOpen={isMobileOpen}
      onMobileClose={onMobileClose}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
      firstText="Eng"
      secondText="K12"
    />
  );
};
